module.exports = __webpack_public_path__ + "media/images/lb/329-c9576b921c32a4d9782dcf4f87cec22a.svg";